<template>
    <custom-container-full :budget-data="budgetData">
        <div class="row main-quantity-select">
            <div class="col-lg-12">
                <div class="block-content">
                    <div style="max-width: 650px; margin: auto">
                        <template v-if="hasPrice">
                            <h4 class="c-question c-question-first">Selecciona la cantidad y formato</h4>
                            <p class="para-1">Puedes seleccionar distintas cantidades en los diversos formatos
                                (número de alvéolos) que tiene esta variedad.</p>
                            <div style="max-width: 450px; margin: auto;">
                                <quantity-select-edit :seeds-by-alveolus.sync="seedsByAlveolus" :seed-price="seedPrice"
                                                      :max-seeds-by-alveolus="maxSeedsByAlveolus"
                                                      :bp-recommended-tray-format-id="bpRecommendedTrayFormatId"
                                                      :bp-recommended-seeds-by-alveolus="bpRecommendedSeedsByAlveolus"
                                                      :has-price="hasPrice" :seed-lost-percent="seedLostPercent"
                                                      :tray-price-base="trayPriceBase"
                                                      :min-order="minOrder" :tray-formats-data="trayFormatsData"
                                                      :injerto="injerto"
                                                      @changed-num-plants="numPlantsChanged"
                                                      @total-price-changed="totalPriceChanged"
                                                      @click-back-varieties-min-order="clickBackVarietiesMinOrder"
                                                      @quantity-select-totals-binds="quantitySelectTotalsBindsChanged"
                                ></quantity-select-edit>
                            </div>
                        </template>
                        <template v-else>
                            <no-price @choose-other-variety="chooseOtherVariety"></no-price>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:columnExtraData>
            <quantity-select-totals v-bind="quantitySelectTotalsBinds" desktop></quantity-select-totals>
            <btn-next :disabled-next="disabledNext" @click="goNext" :url-back="route('custom.variety-select')"></btn-next>
        </template>
    </custom-container-full>
</template>

<script>
    import BtnNext from "./BtnNext";
    import CustomContainerFull from "./CustomContainerFull";
    import AlveolusQuantity from "./AlveolusQuantity";
    import SeedsByAlveolus from "./SeedsByAlveolus";
    import SummaryQuantity from "./SummaryQuantity";
    import AlveolusQuantityMinOrder from "./AlveolusQuantityMinOrder";
    import QuantitySelectTotals from "./QuantitySelectTotals";
    import QuantitySelectEdit from "./QuantitySelectEdit";
    import NoPrice from "./NoPrice";

    export default {
        name: "QuantitySelect",
        props: {
            budgetData: {
                type: Object
            },
            trayFormatsData: {
                type: Array,
                default: []
            },
            minOrder: {
                type: Number
            },
            seedLostPercent: {
                type: Number
            },
            seedPrice: {
                type: Number,
                default: 0
            },
            trayPriceBase: {
                type: Number
            },
            hasPrice: {
                type: Boolean
            },
            bpRecommendedSeedsByAlveolus: {
                type: Number,
                default: 1
            },
            bpRecommendedTrayFormatId: {
                type: Number|String
            },
            maxSeedsByAlveolus: {
                type: Number,
                default: 30
            }
        },
        components: {
            NoPrice,
            QuantitySelectEdit,
            QuantitySelectTotals,
            AlveolusQuantityMinOrder,
            SummaryQuantity,
            SeedsByAlveolus,
            AlveolusQuantity,
            BtnNext, CustomContainerFull
        },
        data() {
            return {
                saving: false,
                numPlants: 0,
                seedsByAlveolus: 1,
                trayFormats: [],
                totalPrice: 0,
                quantitySelectTotalsBinds: {}
            }
        },
        computed: {
            disabledNext() {
                return this.numPlants < 1 || this.saving;
            },
            validTrayFormats () {
                return this.trayFormats.filter(tf => tf.value > 0);
            },
            injerto() {
                return !!this.budgetData.injerto_type;
            }
        },
        watch: {
            trayFormatsData() {
                this.setTrayFormatData();
            },
        },
        methods: {
            goNext() {
                let vm = this;
                vm.saving = true;
                let formData = new FormData();
                formData.append('id', vm.budgetData.id);
                formData.append('num_plants', vm.numPlants);
                formData.append('tray_formats', JSON.stringify(this.trayFormats));
                formData.append('seeds_by_alveolus', vm.seedsByAlveolus);
                formData.append('total_price', vm.totalPrice.toFixed(12));
                axios.post(vm.route('custom.quantity-select-next'), formData).then((response) => {
                    window.location = vm.route('custom.summary');
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                }).finally(() => {
                    vm.saving = false;
                });
            },
            numPlantsChanged(numPlants) {
                this.numPlants = numPlants;
            },
            totalPriceChanged(price) {
                this.totalPrice = price;
            },
            setTrayFormatData() {
                let trayFormats = this.trayFormatsData;
                trayFormats.forEach(tf => {
                    tf.value = 0;
                })
                this.trayFormats = trayFormats;
            },
            trayPrice(trayFormat) {
                return this.trayPriceBase + trayFormat.unidades * this.seedsByAlveolus * this.seedPrice;
            },
            clickBackVarietiesMinOrder() {
                window.location = this.route('custom.variety-select', {'mostrar-pedido-minimo': true});
            },
            quantitySelectTotalsBindsChanged(binds) {
                this.quantitySelectTotalsBinds = binds;
            },
            chooseOtherVariety() {
                window.location = this.route('custom.variety-select');
            }
        },
        created() {
            this.setTrayFormatData();
        }
    }
</script>

<style scoped>
    .block-content {
        text-align: center;
    }

    .c-question-first {
        padding-top: 1.2em;
    }

    .para-1 {
        font-size: 1.2em;
    }

    .item_link > span {
        font-size: 1.2em;
        cursor: pointer;
        margin: 0;
        font-weight: bold;
    }

    .item_link > span {
        margin-left: 0;
    }

    .item_link > span.no-upper {
        text-transform: initial;
    }

    .item_link > span > span.checkbox {
        padding: 0 8.5px;
        border: 1px solid #333;
        position: relative;
    }

    .item_link i {
        position: relative;
        right: 15px;
        z-index: 5;
    }

    .c-buttons > * {
        margin: 0.5em 0 0 0.5em;
        flex: 1 1 auto;
    }

    .c-question {
        font-weight: bold;
        font-size: 1.25rem;
    }


    @media (min-width: 992px) {
        .main-quantity-select {
            padding-bottom: 1rem;
        }

        .c-question-first {
            padding-top: 2.2em;
        }

        .c-question {
            padding-bottom: 0.8em;
        }

    }

    @media (min-width: 575px) {

        .c-buttons > * {
            margin: 1.25em 0 0 1.25em;
        }

    }
</style>
